import { render, staticRenderFns } from "./TipoContactoModalNuevo.vue?vue&type=template&id=44682dfe&scoped=true&"
import script from "./TipoContactoModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoContactoModalNuevo.vue?vue&type=style&index=0&id=44682dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44682dfe",
  null
  
)

export default component.exports